import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=ada4e30a&scoped=true"
import script from "./CourseDetail.vue?vue&type=script&lang=ts"
export * from "./CourseDetail.vue?vue&type=script&lang=ts"
import style0 from "./CourseDetail.vue?vue&type=style&index=0&id=ada4e30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada4e30a",
  null
  
)

export default component.exports